// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"26654":"a5937532ba4fca98","93255":"a0b08d1c71ac7bf1"}[chunkId] + ".css";
};